import { render } from "./ProductsForm.vue?vue&type=template&id=1ee61a54&scoped=true"
import script from "./ProductsForm.vue?vue&type=script&lang=js"
export * from "./ProductsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee61a54"]])

export default __exports__